module.exports = __webpack_public_path__ + "img/edit.e1d010da.png";